import roundAbnt from "../../formaters/roundAbnt";

export type FinalPriceAdjustmentType = "DISCOUNT" | "INCREASE" | "NONE";

export interface FinalPriceAdjustment {
  type: FinalPriceAdjustmentType;
  unitValue: number;
  percentage: number;
  total: number;
  subtotal: number;
}

const finalPriceAdjustment = (
  unitPrice: number,
  finalPrice: number,
  quantity: number,
): FinalPriceAdjustment => {
  const difference = roundAbnt(finalPrice - unitPrice);
  const unitValue = Math.abs(difference);
  const percentage =
    difference > 0 && unitPrice
      ? roundAbnt((unitValue / unitPrice) * 100)
      : 0;

  return {
    type:
      difference > 0
        ? "INCREASE"
        : difference < 0
          ? "DISCOUNT"
          : "NONE",
    unitValue,
    percentage,
    total: roundAbnt(unitValue * quantity),
    subtotal: roundAbnt(finalPrice * quantity),
  };
};

export default finalPriceAdjustment;
